export const PartnersListData = [
  {
    imageName: 'static/img/cml/alibaba_outlined.png',
  },
  {
    imageName: 'static/img/cml/shein_outlined.png',
  },
  {
    imageName: 'static/img/cml/temu_outlined.png',
  },
  {
    imageName: 'static/img/cml/alibaba_outlined.png',
  },
  {
    imageName: 'static/img/cml/shein_outlined.png',
  },
  {
    imageName: 'static/img/cml/temu_outlined.png',
  },
];

